import patternize from '@sdk/helpers/formatters/patternize';
import { CELLPHONE_FORMAT } from '@cordel/helpers/form/validators/cellphone';
import { PHONE_FORMAT } from '@cordel/helpers/form/validators/phone';

export default function setter(value, parent) {
  return patternize(`${parent.code}${value}`, {
    format: PHONE_FORMAT,
    bigFormat: CELLPHONE_FORMAT,
  });
}
